/** 暫定 CorporateSite。画像全体をクリックすると ServiceSite (/service) へ遷移する。 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { MockImagePage } from './MockImagePage';

export const CorporateSitePage: React.FC = () => {
  const nav = useNavigate();
  return (
    <MockImagePage
      src="/mock/corporate.png"
      alt="GB照らす コーポレートサイト"
      onImageClick={() => nav('/service')}
    />
  );
};

export default CorporateSitePage;
